import type { UnitKind } from "./types";
import type { UnitDef } from "./units";

export type UnitDefHoldover = {
  untilDate: string;
  defs: Partial<Record<UnitKind, Partial<UnitDef>>>;
};

export function utcCalendarDate(atMs: number): string {
  return new Date(atMs).toISOString().slice(0, 10);
}

export function applyUnitDefHoldover({
  base,
  kind,
  holdover,
  atMs,
}: {
  base: Record<UnitKind, UnitDef>;
  kind: UnitKind;
  holdover: UnitDefHoldover | null;
  atMs: number;
}): UnitDef {
  const def = base[kind];
  if (!holdover || utcCalendarDate(atMs) >= holdover.untilDate) return def;
  const patch = holdover.defs[kind];
  if (!patch) return def;
  return {
    ...def,
    ...patch,
    damage: patch.damage ? { ...def.damage, ...patch.damage } : def.damage,
  };
}
